/* Window Load functions */
import "./shadowbox";
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';

const $ = window.$;
const jQuery = window.jQuery;

/* same div height */
var equalheight = function (container) {
    var currentTallest = 0,
        currentRowStart = 0,
        rowDivs = new Array(),
        $el,
        topPosition = 0;
    $(container).each(function () {

        $el = $(this);
        $($el).height('auto')
        var topPostion = $el.position().top;

        if (currentRowStart != topPostion) {
            for (var currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                rowDivs[currentDiv].height(currentTallest);
            }
            rowDivs.length = 0; // empty the array
            currentRowStart = topPostion;
            currentTallest = $el.height();
            rowDivs.push($el);
        } else {
            rowDivs.push($el);
            currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
        }
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
            rowDivs[currentDiv].height(currentTallest);
        }
    });
}

$(window).on('load', function () {
    equalheight('.box_process .box');
});

$(window).on('resize,', function () {
    equalheight('.box_process .box');
});

/*on scroll active*/
$(window).on('scroll', function () {
    if ($(this).scrollTop() > 50) {
        $('header').addClass('sticky');
    } else {
        $('header').removeClass('sticky');
    }
});

window.Shadowbox.init({
    language: 'he',
    players: ['img', 'html', 'iframe', 'qt', 'wmp', 'swf', 'flv'],
    skipSetup: true
});

(function (o, u, t, b, a, s, e) {
    window[b] = window[b] || {};
    (e = e || [])['key'] = o;
    e['__obr'] = u.location.href;
    a = [];
    u.location.search.replace('?', '').split('&').forEach(function (q) {
        if (q.startsWith(b) || q.startsWith('_obid')) e[q.split('=')[0]] = q.split('=')[1];
    });
    e['_obid'] = e['_obid'] || (u.cookie.match(/(^|;)\s*_obid\s*=\s*([^;]+)/) || []).pop() || 0;
    for (let k in e) {
        if (e.hasOwnProperty(k)) a.push(encodeURIComponent(k) + '=' + encodeURIComponent(e[k]));
    }
    s = u.createElement('script');
    s.src = t + '?' + a.join('&');
    u.head.appendChild(s);
})('218d82bb-41d8-4903-8e41-37ade0ebfb51', document, 'https://plugin.sopro.io/hq.js', 'outbase');